import { render, staticRenderFns } from "./NotificationRuleSetup.vue?vue&type=template&id=47233e57&scoped=true"
import script from "./NotificationRuleSetup.vue?vue&type=script&lang=ts"
export * from "./NotificationRuleSetup.vue?vue&type=script&lang=ts"
import style0 from "./NotificationRuleSetup.vue?vue&type=style&index=0&id=47233e57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47233e57",
  null
  
)

export default component.exports